import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import './InactiveReportBanner.scss';

interface InactiveReportBannerProps {
  inactiveSamples: number;
}

const InactiveReportBanner: React.FC<InactiveReportBannerProps> = ({
  inactiveSamples,
}) => {
  const { t } = useTranslation();
  return (
    <Row className='mt-2 align-items-center'>
      <Col>
        <div className='inactive-summary-samples'>
          <Row className='inactive-container'>
            <Col>
              <Row>
                <Col>
                  <p className='font-size-9 font-weight-semi-bold fcolor--text-label summary-header-cell'>
                    {t('downloadResultsPkg_summary_reportUpdate').toUpperCase()}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className='font-size-12 font-weight-bold m-0'>
                    {t(
                      inactiveSamples > 1
                        ? 'downloadResultsPkg_summary_inactiveSummaries'
                        : 'downloadResultsPkg_summary_inactiveSummary',
                      { inactiveQty: inactiveSamples }
                    )}
                  </p>
                </Col>
              </Row>
            </Col>
            <Col className='flex-grow-0'>
              <span className='warning-icon font-size-24 fas fa-exclamation-triangle'></span>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default InactiveReportBanner;
